import "vue";
function getMotionElement(el) {
  if ((el == null ? void 0 : el.nodeType) === 3 || (el == null ? void 0 : el.nodeType) === 8)
    return getMotionElement(el.nextSibling);
  return el;
}
export {
  getMotionElement
};
